import TimelineDot from "@mui/lab/TimelineDot";
import { styled } from "@mui/material";

const CDotTimeline = styled(TimelineDot)(({ theme }) => ({ "& .MuiTimelineDot-root": { backgroundColor: theme.palette.common.orange } }));

export default CDotTimeline;
